// native-only-class.decorator.ts
import { Capacitor } from '@capacitor/core';

export function NativeOnlyClass(message?: string) {
  return function <T extends new (...args: any[]) => any>(target: T): T {
    if (Capacitor.isNativePlatform()) {
      return target;
    }

    console.warn(message || `[${target.name}] not support on web`);

    const propertyNames = Object.getOwnPropertyNames(target.prototype);

    for (const key of propertyNames) {
      if (key === 'constructor') continue;

      const descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);
      if (!descriptor || typeof descriptor.value !== 'function') continue;

      descriptor.value = function () {
        return undefined;
      };

      Object.defineProperty(target.prototype, key, descriptor);
    }

    return target;
  };
}
